import React from "react";

/*
  A clickable bar row. A real <button> with aria-pressed, not a click handler on a div: that is what makes it
  keyboard reachable and announces its state. Without `onClick` it is a plain, non-interactive row.
*/
export const BarRow = ({
  label, value, note, max, title,
  onClick, pressed = false, muted = false,
  labelWidth = 116, color
}) => {
  const interactive = typeof onClick === "function";
  const Tag = interactive ? "button" : "div";

  return (
    <Tag
      className="ff-bar-row"
      type={interactive ? "button" : undefined}
      aria-pressed={interactive ? pressed : undefined}
      onClick={onClick}
      title={title}
      data-static={interactive ? undefined : "true"}
      data-muted={muted || undefined}
    >
      <span className="ff-bar-label" style={{ width: labelWidth }}>{label}</span>
      <span className="ff-bar-track" aria-hidden="true">
        <span
          className="ff-bar-fill"
          style={{ width: `${max ? Math.max(2, (value / max) * 100) : 0}%`, background: color }}
        />
      </span>
      <span className="ff-bar-val">{value}</span>
      {note !== undefined && note !== null && <span className="ff-bar-note">{note}</span>}
    </Tag>
  );
};
